import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Flex,
  FormLabel,
} from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { CreditAgreementFullArtifactWipConfigType } from '../../types';
import {
  formatSelectOptions,
  Select,
} from 'packages/common-frontend/components/Select';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';

type EditCapitalProviderConfigProps = {
  wipConfig: CreditAgreementFullArtifactWipConfigType;
  _config_: CreditAgreement.DomainEntity.Items.CapitalProviderConfig;
  basePropertyKey: string;
};
const EditCapitalProviderConfig = ({
  _config_,
  basePropertyKey,
  wipConfig: { formProps },
}: EditCapitalProviderConfigProps) => {
  const { interestRateBase } = _config_;

  const keys: CreditAgreement.DomainEntity.Items.InterestRateBase[] = _.values(
    CreditAgreement.DomainEntity.Items.InterestRateBase,
  );

  const selectOptions = formatSelectOptions(keys, 'sentence');

  return (
    <Flex alignItems="flex-end" mt={5}>
      <FormLabel minW="60">Interest Rate Base</FormLabel>
      <Select
        value={interestRateBase}
        onChange={(val) => {
          formProps.setFieldValue(`${basePropertyKey}.interestRateBase`, val);
        }}
        options={selectOptions}
        width="sm"
      />
    </Flex>
  );
};

type EditPartyEntityConfigProps = {
  partyKey: CreditAgreement.DomainEntity.Items.PartyType;
  wipConfig: CreditAgreementFullArtifactWipConfigType;
  basePropertyKey: string;
  _config_: CreditAgreement.DomainEntity.Items.CapitalProviderConfig; // | other type of configs as well
};
const EditPartyEntityConfig = ({
  partyKey,
  wipConfig,
  basePropertyKey,
  _config_,
}: EditPartyEntityConfigProps) => {
  // I suspect we will need to type cast as TS will fail to narrow _config_
  switch (partyKey) {
    case 'capitalProvider':
      return (
        <EditCapitalProviderConfig
          wipConfig={wipConfig}
          _config_={_config_}
          basePropertyKey={basePropertyKey}
        />
      );
    default:
      throw Error(`Party ${partyKey} is not configured.`);
  }
};

type EditPartyEntityConfigModalProps = {
  // @ts-ignore
  partyKey: CreditAgreement.Items.PartyType;
  basePropertyKey: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  wipConfig: CreditAgreementFullArtifactWipConfigType;
  // @ts-ignore
  _config_: CreditAgreement.Items.CapitalProviderConfig; // | other type of configs as well
};
export const EditPartyEntityConfigModal = ({
  partyKey,
  basePropertyKey,
  isOpen,
  setIsOpen,
  wipConfig,
  _config_,
}: EditPartyEntityConfigModalProps) => {
  const { formProps } = wipConfig;

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)} size="3xl">
      <ModalOverlay />
      <ModalContent padding="20px" minW="3xl">
        <ModalHeader>Edit Party Config</ModalHeader>
        <ModalCloseButton />
        <ModalBody width="100%">
          <EditPartyEntityConfig
            partyKey={partyKey}
            wipConfig={wipConfig}
            basePropertyKey={basePropertyKey}
            _config_={_config_}
          />
          <Flex justifyContent="center" mt="8">
            <Button
              onClick={() => {
                wipConfig.saveCreditAgreementFullArtifactWip({
                  variables: {
                    creditAgreementFullArtifactWip: {
                      id: formProps.values.id,
                      creditFacilityId: formProps.values.creditFacilityId,
                      creditAgreement: JSON.stringify(formProps.values),
                    },
                  },
                });
                setIsOpen(false);
              }}
              aria-label="Done"
              isDisabled={_.keys(formProps.errors).length > 0}
            >
              Done
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
